/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Canonical Speakeasy hook event type.
 */
export const HookIngestEventType = {
  SessionStarted: "session.started",
  SessionUpdated: "session.updated",
  SessionEnded: "session.ended",
  McpInventory: "mcp.inventory",
  PromptSubmitted: "prompt.submitted",
  ToolRequested: "tool.requested",
  ToolCompleted: "tool.completed",
  ToolFailed: "tool.failed",
  AssistantResponded: "assistant.responded",
  AssistantThought: "assistant.thought",
  UsageReported: "usage.reported",
  SkillActivated: "skill.activated",
  NotificationReported: "notification.reported",
  ClientDeliveryFailed: "client.delivery_failed",
} as const;
/**
 * Canonical Speakeasy hook event type.
 */
export type HookIngestEventType = ClosedEnum<typeof HookIngestEventType>;

/**
 * Canonical Speakeasy feature event.
 */
export type HookIngestEvent = {
  /**
   * RFC3339 timestamp from the local agent. Defaults to receive time when absent.
   */
  occurredAt?: Date | undefined;
  /**
   * Canonical Speakeasy hook event type.
   */
  type: HookIngestEventType;
};

/** @internal */
export const HookIngestEventType$outboundSchema: z.ZodMiniEnum<
  typeof HookIngestEventType
> = z.enum(HookIngestEventType);

/** @internal */
export type HookIngestEvent$Outbound = {
  occurred_at?: string | undefined;
  type: string;
};

/** @internal */
export const HookIngestEvent$outboundSchema: z.ZodMiniType<
  HookIngestEvent$Outbound,
  HookIngestEvent
> = z.pipe(
  z.object({
    occurredAt: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    type: HookIngestEventType$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      occurredAt: "occurred_at",
    });
  }),
);

export function hookIngestEventToJSON(
  hookIngestEvent: HookIngestEvent,
): string {
  return JSON.stringify(HookIngestEvent$outboundSchema.parse(hookIngestEvent));
}
